import React from 'react';
import { EntityDescription } from '../../Api/interfaces';
import LinkRow from './LinkRow';
import './styles.css';

interface Props {
  entity: EntityDescription;
  filter: string;
  onTypeClicked?: (type: string) => void;
}

export default class LinksTable extends React.Component<Props> {
  render(): JSX.Element {
    const filter = this.props.filter.toLocaleLowerCase();
    const { entity, onTypeClicked } = this.props;
    const noFilter = filter === '';
    return (
      <tr>
        <td valign="top">
          <div id="Links" className="propertyName">
            Possible Links
          </div>
        </td>
        <td>
          <table className="fieldsTable">
            <tbody>
              <tr className="fieldsHeader">
                <th className="fieldsHeader">From Entity</th>
                <th className="fieldsHeader">From Field</th>
                <th className="fieldsHeader">To Entity</th>
                <th className="fieldsHeader">To Field</th>
              </tr>
              {entity.possibleLinks
                .filter(
                  (l) =>
                    noFilter ||
                    l.fromEntity.toLocaleLowerCase().includes(filter) ||
                    l.fromField.toLocaleLowerCase().includes(filter) ||
                    l.toEntity.toLocaleLowerCase().includes(filter) ||
                    l.toField.toLocaleLowerCase().includes(filter)
                )
                .map((link) => (
                  <LinkRow link={link} onTypeClicked={onTypeClicked} />
                ))}
            </tbody>
          </table>
        </td>
      </tr>
    );
  }
}
